import { Instant, LocalDate, LocalDateTime } from "@js-joda/core";
import { dateFormatter } from "../../shared/utils/date-formatter";
import { CaregiverProfileCaregiver } from "./caregiverProfileModal.types";

export function getCaregiverFullName(caregiver: CaregiverProfileCaregiver) {
  return [caregiver.firstName, caregiver.middleName, caregiver.lastName].filter(Boolean).join(" ");
}

export function getCaregiverPhotoUrl(caregiver: CaregiverProfileCaregiver) {
  return caregiver.photoUrl ?? "admin/images/blank-profile.jpg";
}

export function formatCaregiverProfileValue(value: unknown) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  if (value instanceof LocalDate) {
    return dateFormatter.toDate(value);
  }

  if (value instanceof LocalDateTime || value instanceof Instant) {
    return dateFormatter.toDateTime(value);
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  return String(value);
}

export function formatCaregiverCertifications(
  certifications: CaregiverProfileCaregiver["certifications"],
  certificationNames?: readonly string[] | null
) {
  const displayCertifications =
    certificationNames !== undefined && certificationNames !== null && certificationNames.length > 0
      ? certificationNames
      : certifications;

  if (displayCertifications.length === 0) {
    return "";
  }

  return displayCertifications.map((certification) => String(certification)).join(", ");
}
